(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['app/feature-config/FeatureConfigModel', 'services/authenticationFeatureConfigExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var authenticationFeatureConfigExtService = require('./../urls').authenticationFeatureConfigExtService;
    module.exports = factory(require('./../feature-config/FeatureConfigModel'), authenticationFeatureConfigExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (FeatureConfigModel, authenticationFeatureConfigExtService) {
  'use strict';

  /**
   * Model for authentication configuration information. Uses the AuthenticationFeatureConfigExtService and corresponds to an AuthenticationFeatureConfig
   *
   * @class AuthenticationFeatureConfigModel
   * @extends FeatureConfigModel
   * @constructor
   */
  return new (FeatureConfigModel.extend({
    urlRoot: authenticationFeatureConfigExtService
  }))();
}));
